module.exports = __webpack_public_path__ + "static/media/startup_shap.ad96aba5.png";